import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import SidebarNavigation from 'src/components/SidebarNavigation';

const WPSidebarNavigation = ({ location, pageColors, sidebarVisible }) => {
  const { designPages } = useStaticQuery(graphql`
    query {
      designPages: allWpDesignPage(sort: { fields: menuOrder, order: ASC }) {
        edges {
          node {
            id
            parentId
            title
            designPagesModules {
              sidebarDescription
              wrapUpActivity
            }
            slug
            path: uri
            parent {
              id
            }
            language {
              slug
            }
          }
        }
      }
    }
  `);

  return (
    <SidebarNavigation
      navItems={designPages.edges}
      location={location}
      basePath={location.pathname}
      sidebarVisible={sidebarVisible}
      pageColors={pageColors}
    />
  );
};

export default WPSidebarNavigation;
